module.exports = __webpack_public_path__ + "public/img/14.fcb6955d.png";